import { useRef } from "react"
import { Box, Tabs, tabsClasses } from "@mui/material"
import { TabContext } from "@mui/lab"
import { DragDropContext, Droppable } from "react-beautiful-dnd"
import DraggableTab from "./DraggableTab"
import { useSelector } from "react-redux"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import { AddBucketButtonWrapper } from "./Atom"
import StyledTab from "../StyledTab"
import { useDispatch } from "react-redux"
import { setSelectedTab, setTabs } from "../../../../redux/slices/metricSlice"
import { getTokenLocal } from "../../../../../helper/utils"
import { toast } from "react-toastify"
import BlueprintAPI from "../../../../../api/blueprint"
import PermsWrapper from "../../../Auth/PermsWrapper"
import { permissions } from "../../../../../config/constants"

const bluePrintAPI = new BlueprintAPI()

export default function DraggableTabs(props: any) {
  const dispatch = useDispatch()

  const tabsRef = useRef<any>(null)

  const {
    tabs,
    value,
    handleChange,
    handleBucketCreateOpen,
    handleBucketUpdateOpen,
    handleBucketDeleteOpen,
  } = props

  const selectedTab = useSelector((state: any) => {
    return state.metric.selectedTab
  })

  const onDragEnd = async (result: any) => {
    if (result.source.index == result.destination.index) {
      return
    }

    const token = getTokenLocal()

    const newTabs = Array.from(tabs)
    const draggedTab = newTabs.splice(result.source.index, 1)[0]
    newTabs.splice(result.destination.index, 0, draggedTab)
    dispatch(setTabs([...newTabs]))

    if (result.source.index == selectedTab) {
      dispatch(setSelectedTab(result.destination.index))
    } else {
      if (
        result.source.index < selectedTab &&
        result.destination.index > selectedTab
      ) {
        dispatch(setSelectedTab(selectedTab - 1))
      } else if (
        result.source.index > selectedTab &&
        result.destination.index < selectedTab
      ) {
        dispatch(setSelectedTab(selectedTab + 1))
      }
    }

    const customArr: any = []

    newTabs.forEach((tab: any, index: number) => {
      customArr.push({
        metric_bucket_id: tab?.metric_bucket_id,
        metric_bucket_sequence: index,
      })
    })

    if (token) {
      const response = await bluePrintAPI.resequenceBucket(token, customArr)

      if (
        response?.data?.status_code !== 200 &&
        response?.data?.status_code !== 401
      ) {
        toast.error(response?.data?.display_message)
      } else {
        toast.success(response?.data?.display_message)
      }
    }
  }

  const _renderTabList = (droppableProvided: any) => (
    <Tabs
      ref={tabsRef}
      // scrollButtons
      // ScrollButtonComponent={(props) => <StyledScrollButton {...props} />}
      value={selectedTab}
      onChange={handleChange}
      variant="scrollable"
      aria-label="Draggable Tabs"
      sx={{
        maxWidth: "100%",
        backgroundColor: "#3C77EF",
        height: "8vh",
        display: "flex",
        alignItems: "flex-end",
        color: "primary.main",
        position: "relative",
        // paddingRight: 13,
        [`& .${tabsClasses.scrollButtons}`]: {
          position: "absolute",
          "&.Mui-disabled": { opacity: 0.9 },
        },
      }}
      TabIndicatorProps={{
        style: { display: "none" },
      }}
    >
      <PermsWrapper perm={permissions?.BLUEPRINT_BUCKET_MAINTENANCE}>
        <AddBucketButtonWrapper onClick={handleBucketCreateOpen}>
          <AddCircleOutlineIcon sx={{ color: "#fff", cursor: "pointer" }} />
        </AddBucketButtonWrapper>
      </PermsWrapper>

      {tabs.map((tab: any, index: any) => {
        const child = (
          <StyledTab
            tab={tab}
            index={index}
            handleChange={handleChange}
            selectedTab={selectedTab}
            handleBucketUpdateOpen={handleBucketUpdateOpen}
            handleBucketDeleteOpen={handleBucketDeleteOpen}
          />
        )

        return (
          <DraggableTab
            label={tab.metric_bucket}
            value={tab.metric_bucket_id}
            index={index}
            key={index}
            child={child}
          />
        )
      })}

      {droppableProvided ? droppableProvided.placeholder : null}
    </Tabs>
  )

  const _renderTabListWrappedInDroppable = () => (
    <DragDropContext onDragEnd={onDragEnd}>
      <Box
        sx={{
          display: "flex",
          overflow: "auto",
          backgroundColor: "#3C77EF",
        }}
        // className="styled-scrollbar"
      >
        <Droppable droppableId="1" direction="horizontal">
          {(droppableProvided: any) => (
            <Box
              ref={droppableProvided.innerRef}
              {...droppableProvided.droppableProps}
              {...droppableProvided.dropHandleProps}
            >
              {_renderTabList(droppableProvided)}
            </Box>
          )}
        </Droppable>
      </Box>
    </DragDropContext>
  )

  return (
    <Box sx={{ width: "100%" }}>
      <TabContext value={value}>
        {_renderTabListWrappedInDroppable()}
      </TabContext>
    </Box>
  )
}
